export const FiDisplayAs = {
    Image: {
        Id: 1,
        TextId: 'common.image',
    },
    DownloadableFile: {
        Id: 2,
        TextId: 'common.downloadable_file',
    },
};
